import(/* webpackMode: "eager" */ "/app/node_modules/next-runtime-env/build/provider/env-provider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next-runtime-env/build/provider/use-env-context.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/src/ui/app/(search)/styles/search-layout.scss");
;
import(/* webpackMode: "eager", webpackExports: ["HeaderBase"] */ "/app/src/ui/sections/common/header/header-base.tsx");
